import axios from 'axios'

export function getRtctoken(params) {
    const { channel, agoraUid, chatUserId } = params;
    const url = `https://a41.chat.agora.io/token/rtc/channel/${channel}/agorauid/${agoraUid}?userAccount=${chatUserId}`
    return axios
        .get(url)
        .then(function (response) {
            console.log('getRtctoken', response)
            return response.data;
        })
        .catch(function (error) {
            console.log(error);
        });
}

export function getConfDetail(username, channelName) {
    const url = `https://a41.chat.agora.io/agora/channel/mapper?channelName=${channelName}&userAccount=${username}`

    return axios.get(url)
        .then(function (response) {
            
            const modal = document.querySelector(".callkit-layout-cantainer");
            if (modal) {
                modal.addEventListener("touchend", function (e) {
                    // look for button OR icon inside modal
                    const target = e.target.closest("button" ,"i, [role='button']");
                    if (target && modal.contains(target)) {
                        e.preventDefault(); // avoid ghost double clicks
                        console.log("👉 Touchend on", target);
                        target.click(); // trigger synthetic click
                    }
                });

                console.log("✅ Touch→Click fallback enabled for buttons & icons in modal");
            } else {
                console.log("❌ Modal not found");
            }
            
            let members = response.data.result
            return members
        })
        .catch(function (error) {
            console.log(error);
        });
}